__turbopack_context__.v({
  "content": "CardPolaroid-module-scss-module__V7ImBG__content",
  "cta": "CardPolaroid-module-scss-module__V7ImBG__cta",
  "fade-in": "CardPolaroid-module-scss-module__V7ImBG__fade-in",
  "flag": "CardPolaroid-module-scss-module__V7ImBG__flag",
  "hasDate": "CardPolaroid-module-scss-module__V7ImBG__hasDate",
  "headline": "CardPolaroid-module-scss-module__V7ImBG__headline",
  "image": "CardPolaroid-module-scss-module__V7ImBG__image",
  "inner": "CardPolaroid-module-scss-module__V7ImBG__inner",
  "label": "CardPolaroid-module-scss-module__V7ImBG__label",
  "month": "CardPolaroid-module-scss-module__V7ImBG__month",
  "paragraph": "CardPolaroid-module-scss-module__V7ImBG__paragraph",
  "productCard": "CardPolaroid-module-scss-module__V7ImBG__productCard",
  "root": "CardPolaroid-module-scss-module__V7ImBG__root",
});
